import { render, staticRenderFns } from "./milieuxList.vue?vue&type=template&id=7c8b1fb0&"
import script from "./milieuxList.vue?vue&type=script&lang=js&"
export * from "./milieuxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports